import axiosInstance from "axios";
import Cookie from "js-cookie";
import { MS_NAME } from "../constants/Constants";
var jwt = require("jsonwebtoken");
class AxiosMSClient {
  constructor() {
    this.init();
  }

  init() {
    // should run if .get function does exist
    if (Cookie?.get) {
      let token = Cookie.get("X_TKN");
      let decodedToken = jwt.decode(token);

      localStorage.setItem("reload_count", 0);
      if (
        decodedToken &&
        decodedToken.exp < Math.ceil(new Date().getTime() / 1000)
      ) {
        this.clearSession();
      } else if (!decodedToken) {
        this.clearSession();
      } else {
        localStorage.removeItem("timeoutMsg");
      }

      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;
    } else {
      // runs when if returns undefined for .get
      const reloadCount = localStorage.getItem("reload_count"); // set in GlobalState.js (should be present at all times)
      if (parseInt(reloadCount) < 2) {
        localStorage.setItem("reload_count", parseInt(reloadCount) + 1); // increment count
        location.reload();
      } else {
        localStorage.setItem("reload_count", 0);
        this.clearSession(); // eventually goes to login page
      }
    }
  }

  getInstance(msPath) {
    axiosInstance.defaults.baseURL = msPath;
    return axiosInstance;
  }

  clearSession() {
    Cookie.remove("X_TKN");
    Cookie.remove("userName");
    Cookie.remove("email");
    localStorage.setItem(
      "timeoutMsg",
      "Your session has expired. Please login again to continue working."
    );
  }
}

const MSClient = new AxiosMSClient();

export const axios = () => MSClient.getInstance(MS_NAME.VENDORPROFILE);
export const axiosBase = () => MSClient.getInstance("");
export const axiosReport = () => MSClient.getInstance(MS_NAME.REPORT);
export const axiosNotification = () =>
  MSClient.getInstance(MS_NAME.NOTIFICATION);
export const axiosDocument = () => MSClient.getInstance(MS_NAME.DOCUMENT);
export const axiosNotes = () => MSClient.getInstance(MS_NAME.NOTES);
export const axiosMarketplaceVendor = () =>
  MSClient.getInstance(MS_NAME.MARKETPLACE_VENDOR);
export const axiosDocLibrary = () => MSClient.getInstance(MS_NAME.DOC_LIBRARY);
export const axiosFom = () => MSClient.getInstance(MS_NAME.FOM);

export default axios;
